import React, { ComponentType, HTMLAttributes } from 'react';
import { styled } from '@mui/material';


const LeftSide: ComponentType<HTMLAttributes<HTMLDivElement>> = styled('div')`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: start;
`;

export default LeftSide;